<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';
import requestApi from '@/utils/requestApi';

const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();

const myForm = ref(null)
const form = ref(false)
const exameBeta = ref(null)
const exameUltrassom = ref(null)
const exameBeta64 = ref(null)
const exameUltrassom64 = ref(null)
const trilha = ref(window.ovmConfig.env['TRILHA'])

onMounted(() => {
  felixBagAuxStore.pauseVideo()
});

function required(v) {
  if (v) return true

  return "Campo obrigatório"
}

function upload(upload, type) {
  let file = upload[0]
  const reader = new FileReader();
  reader.onloadend = () => {
    let rawImg = reader.result;
    if (type === 'beta') {
      exameBeta64.value = rawImg
    } else if (type === 'ultrassom') {
      exameUltrassom64.value = rawImg
    }
  }
  reader.readAsDataURL(file)
}

async function onSubmit(event) {
  const results = await event
  if (results.valid) {
    if (exameBeta.value !== null) {
      uploadDocumentToApi('Exame Beta', exameBeta64.value, 'EXAME_BETA', exameBeta.value[0].type.split('/').pop())
    }
    if (exameUltrassom.value !== null) {
      uploadDocumentToApi('Exame Ultrassom', exameUltrassom64.value, 'EXAME_ULTRASSOM', exameUltrassom.value[0].type.split('/').pop())
    }
  }
}

async function uploadDocumentToApi(docType, docToUpload, docName, doc) {
  let cpfChave = window.ovmConfig.env['CPF'].toString();
  let docExtension = ''
  if (doc) {
    if (doc.toLowerCase() === 'png') {
      docExtension = '.png';
    } else if (doc.substring(0, 3).toLowerCase() === 'svg') {
      docExtension = '.svg';
    } else if (doc.toLowerCase() === 'jpeg') {
      docExtension = '.jpeg';
    } else if (doc.toLowerCase() === 'pdf') {
      docExtension = '.pdf';
    }
  }
  let nomeDoc = docName + docExtension
  var body = {
    type: docType,
    replace: 'true',
    files: [
      {
        name: nomeDoc,
        content: docToUpload,
      },
    ],
  };

  await requestApi({
    url: `/v2/documents/${cpfChave}/upload`,
    method: "PATCH",
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    },
    dataType: 'json',
    data: JSON.stringify(body)
  }).then(response => {
    console.log("Sucesso!");
    console.log(response.data)
    globalStateStore.exames[docName].status = 'REVIEW'
  }).catch(function (error) {
    console.log("Erro na criação de expectativa de documentos!");
    console.log(error)
  })
}

</script>

<template>
  <div id="upload-exame">
    <div class="header">
      <div style="display: flex; flex-direction: column; align-items: start; width: 60%;">
        <v-btn
          @click="felixBagAuxStore.hideInteractive('upload-exame')"
          variant="text" color="inherit"><img
            src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
            alt=""></v-btn>
        <p class="submenu-title">Exames</p>
      </div>
    </div>

    <v-form class="forms" ref="myForm" validate-on="submit lazy" @submit.prevent="onSubmit" v-model="form">
      <p class="label">Anexo do exame de Ultrassom com idade gestacional (O arquivo enviado deve, obrigatoriamente, conter o laudo do exame.)*</p>
      <v-file-input density="compact" :prepend-icon="null" v-model="exameUltrassom" label="Exame de Ultrassom"
        variant="outlined" :disabled="globalStateStore.exames['EXAME_ULTRASSOM'].status === 'VALID' || globalStateStore.exames['EXAME_ULTRASSOM'].status === 'REVIEW'" @change="upload(exameUltrassom, 'ultrassom')" 
        :rules="globalStateStore.exames['EXAME_ULTRASSOM'].status === 'INVALID' ? [required] : []" accept="application/pdf,image/*" style="margin-top: 3%;">
        <template v-slot:append-inner>
          <img
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/96ed24e9-194e-4e45-9073-81efa9b8cb84.svg"
            alt="">
        </template>
      </v-file-input>
      <p v-if="globalStateStore.exames['EXAME_ULTRASSOM'].status === 'REVIEW'" style="color: #660099; text-align: left; font-size: 12px;">Pendente de aprovação</p>
      <p v-if="globalStateStore.exames['EXAME_ULTRASSOM'].status === 'VALID'" style="color: #81D300; text-align: left; font-size: 12px;">Exame Aprovado</p>
      <p v-if="globalStateStore.exames['EXAME_ULTRASSOM'].status === 'INVALID'" style="color: red; text-align: left; font-size: 12px;">Erro no envio. Por favor, anexe um novo arquivo</p>
      <div v-if="['parceria'].includes(trilha)">
        <p class="label">Anexo do exame de Beta HCG (O arquivo enviado deve, obrigatoriamente, conter o laudo do exame.)*</p>
        <v-file-input :disabled="globalStateStore.exames['EXAME_BETA'].status === 'VALID' || globalStateStore.exames['EXAME_BETA'].status === 'REVIEW'" density="compact" :prepend-icon="null" v-model="exameBeta" label="Exame de Beta HCG"
          variant="outlined" @change="upload(exameBeta, 'beta')" :rules="globalStateStore.exames['EXAME_BETA'].status === 'INVALID' ? [required] : []" accept="application/pdf,image/*" style="margin-top: 3%;">
          <template v-slot:append-inner>
            <img
              src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/96ed24e9-194e-4e45-9073-81efa9b8cb84.svg"
              alt="">
          </template>
        </v-file-input>
        <p v-if="globalStateStore.exames['EXAME_BETA'].status === 'REVIEW'" style="color: #660099; text-align: left; font-size: 12px;">Pendente de aprovação</p>
        <p v-if="globalStateStore.exames['EXAME_BETA'].status === 'VALID'" style="color: #81D300; text-align: left; font-size: 12px;">Exame Aprovado</p>
        <p v-if="globalStateStore.exames['EXAME_BETA'].status === 'INVALID'" style="color: red; text-align: left; font-size: 12px;">Erro no envio. Por favor, anexe um novo arquivo</p>
      </div>
      <v-btn flat style="position: absolute; bottom: 14%; left: 7.5%; width: 85%;" type="submit" color="#660099" @click="submitForm" class="text-none">Fazer Upload</v-btn>
    </v-form>
  </div>
</template>

<style scoped>
#upload-exame {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  z-index: 1;
}

.header {
  height: 20%;
  background-color: #BC4AFF;
  display: flex;
}

.submenu-title {
  color: white;
  margin-top: 15%;
  font-size: 20px;
  text-align: start;
  margin-left: 12%;
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6E7FF;
  border-radius: 50%;
}

.title {
  margin-top: 25%;
  color: #fff;
  font-size: 22px;

}

.subtitle {
  color: black;
  font-weight: bold;
  margin-top: 3%;
  text-align: start;
  font-size: 14px;
}

.forms {
  overflow: auto;
  height: 60%;
  width: 85%;
  margin-left: 7.5%;
}

.label {
  font-size: 13px;
  text-align: start;
  margin-top: 5%;
}
</style>